<template>
    <v-card-component :title="cardTitle" :icon="cardIcon">
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="12" lg="4" sm="6">
                <div class="d-flex flex-row justify-space-between">
                    <span class="body-2 font-weight-medium">
                        Blood Group <span class="error--text" v-if="required">*</span>
                    </span>
                    <ApproveRejectButton
                        v-if="value.basic && value.basic[0].bloodGroup && (value.basic[0].bloodGroup !== compareHealthData.bloodGroup)"
                        fieldType="bloodGroup"
                        :approveRowId="value.basic[0].id"
                        :isChange = "value.basic[0].isChange"
                        :fieldValue="value.basic[0].bloodGroup"
                        @click="approveRejectHealthRequest"
                    />
                </div>
                <v-autocomplete
                    :value="value.basic && value.basic[0].bloodGroup ? value.basic[0].bloodGroup : compareHealthData.bloodGroup"
                    :class="value.basic && value.basic[0].bloodGroup && (value.basic[0].bloodGroup !== compareHealthData.bloodGroup) ? 'custom-text-color' : ''"
                    key="id"
                    class="my-0 py-1"
                    single-line
                    label="---Select---"
                    :items="bloodGroupList"
                    :required="required"
                    item-text="value"
                    item-value="value"
                    disabled
                />
            </v-col>
            <v-col cols="12" lg="4" sm="6">
                <div class="d-flex flex-row justify-space-between">
                    <span class="body-2 font-weight-medium">
                        Serious accidents/illness/operations <span class="error--text " v-if="required">*</span>
                    </span>
                    <ApproveRejectButton
                        v-if="value.basic && value.basic[0].anySeriousAccidentsOrIllnessOrOperarions && (value.basic[0].anySeriousAccidentsOrIllnessOrOperarions !== compareHealthData.anySeriousAccidentsOrIllnessOrOperarions)"
                        :approveRowId="value.basic[0].id"
                        :isChange = "value.basic[0].isChange"
                        fieldType="anySeriousAccidentsOrIllnessOrOperarions"
                        :fieldValue="value.basic[0].anySeriousAccidentsOrIllnessOrOperarions"
                        @click="approveRejectHealthRequest"
                    />
                </div>
                <v-text-field
                    type="text"
                    placeholder="Specify if any, else write NA"
                    class="my-0 py-1"
                    :value="value.basic && value.basic[0].anySeriousAccidentsOrIllnessOrOperarions ? value.basic[0].anySeriousAccidentsOrIllnessOrOperarions : compareHealthData.anySeriousAccidentsOrIllnessOrOperarions"
                    :required="required"
                    :class="value.basic && value.basic[0].anySeriousAccidentsOrIllnessOrOperarions && (value.basic[0].anySeriousAccidentsOrIllnessOrOperarions !== compareHealthData.anySeriousAccidentsOrIllnessOrOperarions) ? 'custom-text-color' : ''"
                    single-line
                    disabled
                />
            </v-col>
            <v-col cols="12" lg="4" sm="6">
                <span
                    class="body-2 font-weight-medium">
                    Specify date of Serious accidents / operations
                </span>
                <custom-date-picker
                    :maxToDate="maxToDate"
                    v-model.trim="compareHealthData.dateForSeriousAccidentsOrIllnessOrOperarions"
                />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">
                Any other aliment please specify
                <span class="error--text " v-if="required">*</span>
            </span>
            <v-text-field
                type="text"
                placeholder="Other aliment, else write NA"
                class="my-0 py-1"
                v-model="compareHealthData.anyOtherAliment"
                :required="required"
                single-line
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">
                Special care ( if required, please specify)
                <span class="error--text " v-if="required">*</span>
            </span>
            <v-text-field
                type="text"
                placeholder="Specify if any, else write NA"
                class="my-0 py-1"
                v-model="compareHealthData.specialCare"
                :required="required"
                single-line
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">
                Allergies/Asthma/Breathlessness
                <span class="error--text " v-if="required">*</span>
            </span>
            <v-text-field
                type="text"
                placeholder="Specify if any, else write NA"
                class="my-0 py-1"
                v-model="compareHealthData.allergiesOrAsthmaOrBreathlessness"
                :required="required"
                single-line
            />
        </v-col>
        <v-col cols="12">
          <h1><span class="warning--text"><b>Diagnostic & Medical Information</b></span></h1>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Identified food allergies, if any ( and treatment given normally )
                    <span class="error--text " v-if="required">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value.medicalInfo && value.medicalInfo[0].foodAllergies && (value.medicalInfo[0].foodAllergies !== compareHealthData.foodAllergies)"
                    fieldType="foodAllergies"
                    :isChange = "value.medicalInfo[0].isChange"
                    :approveRowId="value.medicalInfo[0].id"
                    :fieldValue="value.medicalInfo[0].foodAllergies"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Specify if any, else write NA"
                class="my-0 py-1"
                :value="value.medicalInfo && value.medicalInfo[0].foodAllergies ? value.medicalInfo[0].foodAllergies : compareHealthData.foodAllergies"
                :required="required"
                single-line
                :class="value.medicalInfo && value.medicalInfo[0].foodAllergies && (value.medicalInfo[0].foodAllergies !== compareHealthData.foodAllergies) ? 'custom-text-color' : ''"
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Drug allergies, if any <br>( and treatment given normally )
                    <span class="error--text" v-if="required">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value.medicalInfo && value.medicalInfo[0].drugAllergies && (value.medicalInfo[0].drugAllergies !== compareHealthData.drugAllergies)"
                    fieldType="drugAllergies"
                    :approveRowId="value.medicalInfo[0].id"
                    :isChange = "value.medicalInfo[0].isChange"
                    :fieldValue="value.medicalInfo[0].drugAllergies"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Specify if any, else write NA"
                class="my-0 py-1"
                :value="value.medicalInfo && value.medicalInfo[0].drugAllergies ? value.medicalInfo[0].drugAllergies : compareHealthData.drugAllergies"
                :required="required"
                :class="value.medicalInfo && value.medicalInfo[0].drugAllergies && (value.medicalInfo[0].drugAllergies !== compareHealthData.drugAllergies) ? 'custom-text-color' : ''"
                single-line
                disabled
            />
        </v-col>
        <!--prescription starts here-->
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Please upload images of any prescribed medication that your child is taking.
                    <span class="error--text" v-if="required">*</span>
                </span>
            </div>
            <v-file-input
              accept=".png,.jpeg"
              placeholder="Accepts jpeg, png only"
              disabled
            ></v-file-input>
            <span v-if="value.medicalInfo && value.medicalInfo[0].IEenquiryRegistrationHealthCertiMaps">
              <div v-for="(file, i) in value.medicalInfo[0].IEenquiryRegistrationHealthCertiMaps"
                  :key="i">
                   <v-chip
                  color="primary"
                  label
                  outlined
                  class="ma-2"
                >
                  {{ file.name }}

              </v-chip>
               <ApproveRejectButton
                    v-if="value.medicalInfo && value.medicalInfo[0].IEenquiryRegistrationHealthCertiMaps && (value.medicalInfo[0].IEenquiryRegistrationHealthCertiMaps !== compareHealthData.IEenquiryRegistrationHealthCertiMaps)"
                    fieldType="prescribedMedication"
                    :approveRowId="value.medicalInfo[0].id"
                    :isChange = "value.medicalInfo[0].isChange"
                    :fieldValue="file.healthCertificateUrl"
                    :file="file"
                    @click="approveRejectHealthRequest"
                />
              </div>

            </span>
        </v-col>
        <!--prescription ends here-->
        <v-col cols="12" lg="8" sm="6">
          <div class="d-flex flex-row justify-space-between">
            <span class="body-2 font-weight-medium">
                Does your child have any physical challenges, learning difficulties, special needs? If yes please mention detail
                <span class="error--text " v-if="required">*</span>
            </span>
            <ApproveRejectButton
                v-if="value.medicalInfo && value.medicalInfo[0].anyPhysicalChallengeOrLearningDifficulties && (value.medicalInfo[0].anyPhysicalChallengeOrLearningDifficulties !== compareHealthData.anyPhysicalChallengeOrLearningDifficulties)"
                fieldType="anyPhysicalChallengeOrLearningDifficulties"
                :approveRowId="value.medicalInfo[0].id"
                :isChange = "value.medicalInfo[0].isChange"
                :fieldValue="value.medicalInfo[0].anyPhysicalChallengeOrLearningDifficulties"
                @click="approveRejectHealthRequest"
            />
          </div>
            <v-text-field
                type="text"
                placeholder="Specify if any, else write NA "
                class="my-0 py-1"
                :value="value.medicalInfo && value.medicalInfo[0].anyPhysicalChallengeOrLearningDifficulties ? value.medicalInfo[0].anyPhysicalChallengeOrLearningDifficulties : compareHealthData.anyPhysicalChallengeOrLearningDifficulties"
                :class="value.medicalInfo && value.medicalInfo[0].anyPhysicalChallengeOrLearningDifficulties && (value.medicalInfo[0].anyPhysicalChallengeOrLearningDifficulties !== compareHealthData.anyPhysicalChallengeOrLearningDifficulties) ? 'custom-text-color' : ''"
                :required="required"
                single-line
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">
                What technique(s) do you usually use to discipline your child?
                <span class="error--text" v-if="required">*</span>
            </span>
            <v-text-field
                type="text"
                placeholder="Specify if any, else write NA"
                class="my-0 py-1"
                v-model="compareHealthData.techniqueToDisciplineYourChild"
                :required="required"
                single-line
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">
                What is your child's usual reaction to being disciplined?
                <span class="error--text" v-if="required">*</span>
            </span>
            <v-text-field
                type="text"
                placeholder="Specify if any, else write NA"
                class="my-0 py-1"
                v-model="compareHealthData.childsUsualReactionToBeingDisciplined"
                :required="required"
                single-line
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">
                Does your child usually accept new people easily?
                <span class="error--text" v-if="required">*</span>
            </span>
          <v-radio-group v-model="compareHealthData.isNewPeopleEasilyAcceptable" mandatory row>
            <v-radio label="Yes" name="match" value="Yes" class="mr-7" :required="required">
            </v-radio>
            <v-radio label="No" name="match" value="No" class="mr-7" :required="required">
            </v-radio>
            <v-radio label="UnSure" name="match" value="UnSure">
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12">
            <h1>
                <span class="warning--text">
                    <b>
                        Particulars of General Physician/Family Doctor
                        <span class="error--text" v-if="required">*</span>
                    </b>
                </span>
            </h1>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Name <span class="error--text" v-if="required">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value.physicianDoctorInfo && value.physicianDoctorInfo[0].familyDoctorOrPhysicianName && (value.physicianDoctorInfo[0].familyDoctorOrPhysicianName !== compareHealthData.familyDoctorOrPhysicianName)"
                    fieldType="familyDoctorOrPhysicianName"
                    :approveRowId="value.physicianDoctorInfo[0].id"
                    :isChange = "value.physicianDoctorInfo[0].isChange"
                    :fieldValue="value.physicianDoctorInfo[0].familyDoctorOrPhysicianName"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Name"
                class="my-0 py-1"
                :value="value.physicianDoctorInfo && value.physicianDoctorInfo[0].familyDoctorOrPhysicianName ? value.physicianDoctorInfo[0].familyDoctorOrPhysicianName : compareHealthData.familyDoctorOrPhysicianName"
                :class="value.physicianDoctorInfo && value.physicianDoctorInfo[0].familyDoctorOrPhysicianName && (value.physicianDoctorInfo[0].familyDoctorOrPhysicianName !== compareHealthData.familyDoctorOrPhysicianName) ? 'custom-text-color' : ''"
                :required="required"
                single-line
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Qualification <span class="error--text" v-if="required">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value.physicianDoctorInfo && value.physicianDoctorInfo[0].familyDoctorOrPhysicianQualification && (value.physicianDoctorInfo[0].familyDoctorOrPhysicianQualification !== compareHealthData.familyDoctorOrPhysicianQualification)"
                    fieldType="familyDoctorOrPhysicianQualification"
                    :approveRowId="value.physicianDoctorInfo[0].id"
                    :isChange = "value.physicianDoctorInfo[0].isChange"
                    :fieldValue="value.physicianDoctorInfo[0].familyDoctorOrPhysicianQualification"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Qualification, else NA"
                class="my-0 py-1"
                :value="value.physicianDoctorInfo && value.physicianDoctorInfo[0].familyDoctorOrPhysicianQualification ? value.physicianDoctorInfo[0].familyDoctorOrPhysicianQualification : compareHealthData.familyDoctorOrPhysicianQualification"
                :class="value.physicianDoctorInfo && value.physicianDoctorInfo[0].familyDoctorOrPhysicianQualification && (value.physicianDoctorInfo[0].familyDoctorOrPhysicianQualification !== compareHealthData.familyDoctorOrPhysicianQualification) ? 'custom-text-color' : ''"
                :required="required"
                single-line
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Practicing Clinic/Hospital details
                    <span class="error--text" v-if="required">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicDetails && (value.physicianDoctorInfo[0].practicingClinicDetails !== compareHealthData.practicingClinicDetails)"
                    fieldType="practicingClinicDetails"
                    :approveRowId="value.physicianDoctorInfo[0].id"
                    :isChange = "value.physicianDoctorInfo[0].isChange"
                    :fieldValue="value.physicianDoctorInfo[0].practicingClinicDetails"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                type="text"
                placeholder="Specify if any, else write NA"
                class="my-0 py-1"
                :value="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicDetails ? value.physicianDoctorInfo[0].practicingClinicDetails : compareHealthData.practicingClinicDetails"
                :class="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicDetails && (value.physicianDoctorInfo[0].practicingClinicDetails !== compareHealthData.practicingClinicDetails) ? 'custom-text-color' : ''"
                :required="required"
                single-line
                disabled
            >
          </v-text-field>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Office Telephone
                    <span class="error--text" v-if="required">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicOfficeTelephone && (value.physicianDoctorInfo[0].practicingClinicOfficeTelephone !== compareHealthData.practicingClinicDetails)"
                    fieldType="practicingClinicOfficeTelephone"
                    :approveRowId="value.physicianDoctorInfo[0].id"
                    :isChange = "value.physicianDoctorInfo[0].isChange"
                    :fieldValue="value.physicianDoctorInfo[0].practicingClinicOfficeTelephone"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                placeholder="Number"
                type="number"
                class="my-0 py-1"
                :value="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicOfficeTelephone ? value.physicianDoctorInfo[0].practicingClinicOfficeTelephone : compareHealthData.practicingClinicDetails"
                :class="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicOfficeTelephone && (value.physicianDoctorInfo[0].practicingClinicOfficeTelephone !== compareHealthData.practicingClinicOfficeTelephone) ? 'custom-text-color' : ''"
                :required="required"
                single-line
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Mobile
                    <span class="error--text" v-if="required">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicMobileNo && (value.physicianDoctorInfo[0].practicingClinicMobileNo !== compareHealthData.practicingClinicMobileNo)"
                    fieldType="practicingClinicMobileNo"
                    :approveRowId="value.physicianDoctorInfo[0].id"
                    :isChange = "value.physicianDoctorInfo[0].isChange"
                    :fieldValue="value.physicianDoctorInfo[0].practicingClinicMobileNo"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                placeholder="Number"
                type="number"
                class="my-0 py-1"
                :value="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicMobileNo ? value.physicianDoctorInfo[0].practicingClinicMobileNo : compareHealthData.practicingClinicMobileNo"
                :class="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicMobileNo && (value.physicianDoctorInfo[0].practicingClinicMobileNo !== compareHealthData.practicingClinicMobileNo) ? 'custom-text-color' : ''"
                :required="required"
                single-line
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Email Id
                    <span class="error--text" v-if="required">*</span>
                </span>
                <ApproveRejectButton
                    v-if="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicEmailID && (value.physicianDoctorInfo[0].practicingClinicEmailID !== compareHealthData.practicingClinicEmailID)"
                    fieldType="practicingClinicEmailID"
                    :approveRowId="value.physicianDoctorInfo[0].id"
                    :isChange = "value.physicianDoctorInfo[0].isChange"
                    :fieldValue="value.physicianDoctorInfo[0].practicingClinicEmailID"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                placeholder="Email"
                type="email"
                class="my-0 py-1"
                :value="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicEmailID ? value.physicianDoctorInfo[0].practicingClinicEmailID : compareHealthData.practicingClinicEmailID"
                :class="value.physicianDoctorInfo && value.physicianDoctorInfo[0].practicingClinicEmailID && (value.physicianDoctorInfo[0].practicingClinicEmailID !== compareHealthData.practicingClinicEmailID) ? 'custom-text-color' : ''"
                :required="required"
                disabled
            />
        </v-col>
        <v-col cols="12">
            <h1>
                <span class="warning--text">
                    <b>
                      Vaccination Details
                    </b>
                </span>
            </h1>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Vaccination Details
                </span>
                <ApproveRejectButton
                    v-if="value.vaccination && value.vaccination[0].chikenpoxVaricellaVaccineDate && (value.vaccination[0].chikenpoxVaricellaVaccineDate !== compareHealthData.chikenpoxVaricellaVaccineDate)"
                    fieldType="chikenpoxVaricellaVaccineDate"
                    :approveRowId="value.vaccination[0].id"
                    :isChange = "value.vaccination[0].isChange"
                    :fieldValue="value.vaccination[0].chikenpoxVaricellaVaccineDate"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                type="text"
                class="my-0 py-1"
                :value="value.vaccination && value.vaccination[0].chikenpoxVaricellaVaccineDate ? formatDate(value.vaccination[0].chikenpoxVaricellaVaccineDate) : formatDate(compareHealthData.chikenpoxVaricellaVaccineDate)"
                :class="value.vaccination && value.vaccination[0].chikenpoxVaricellaVaccineDate && (value.vaccination[0].chikenpoxVaricellaVaccineDate !== compareHealthData.chikenpoxVaricellaVaccineDate) ? 'custom-text-color' : ''"
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">Diptheria - DTap*Vaccine </span>
            <v-text-field
                type="date"
                class="my-0 py-1"
                :value="compareHealthData.diptheriaDTapVaccineDate"
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Haemophilus influenza Type B - HiB Vaccine
                </span>
                <ApproveRejectButton
                    v-if="value.vaccination && value.vaccination[0].haemophilusInfluenzaTypeBHiBVaccineDate && (value.vaccination[0].haemophilusInfluenzaTypeBHiBVaccineDate !== compareHealthData.haemophilusInfluenzaTypeBHiBVaccineDate)"
                    fieldType="haemophilusInfluenzaTypeBHiBVaccineDate"
                    :approveRowId="value.vaccination[0].id"
                    :isChange = "value.vaccination[0].isChange"
                    :fieldValue="value.vaccination[0].haemophilusInfluenzaTypeBHiBVaccineDate"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                type="text"
                class="my-0 py-1"
                :value="(value.vaccination && value.vaccination[0].haemophilusInfluenzaTypeBHiBVaccineDate) ? formatDate(value.vaccination[0].haemophilusInfluenzaTypeBHiBVaccineDate) : formatDate(compareHealthData.haemophilusInfluenzaTypeBHiBVaccineDate)"
                :class="value.vaccination && value.vaccination[0].haemophilusInfluenzaTypeBHiBVaccineDate && (value.vaccination[0].haemophilusInfluenzaTypeBHiBVaccineDate !== compareHealthData.haemophilusInfluenzaTypeBHiBVaccineDate) ? 'custom-text-color' : ''"
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Hepatitis A - HepA Vaccine
                </span>
                <ApproveRejectButton
                    v-if="value.vaccination && value.vaccination[0].hepatitisAHepAVaccineDate && (value.vaccination[0].hepatitisAHepAVaccineDate !== compareHealthData.hepatitisAHepAVaccineDate)"
                    fieldType="hepatitisAHepAVaccineDate"
                    :approveRowId="value.vaccination[0].id"
                    :isChange = "value.vaccination[0].isChange"
                    :fieldValue="value.vaccination[0].hepatitisAHepAVaccineDate"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                type="text"
                class="my-0 py-1"
                :value="value.vaccination && value.vaccination[0].hepatitisAHepAVaccineDate ? formatDate(value.vaccination[0].hepatitisAHepAVaccineDate) : formatDate(compareHealthData.hepatitisAHepAVaccineDate)"
                :class="value.vaccination && value.vaccination[0].hepatitisAHepAVaccineDate && (value.vaccination[0].hepatitisAHepAVaccineDate !== compareHealthData.hepatitisAHepAVaccineDate) ? 'custom-text-color' : ''"
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Hepatitis B - HepB Vaccine
                </span>
                <ApproveRejectButton
                    v-if="value.vaccination && value.vaccination[0].hepatitisBHepBVaccineDate && (value.vaccination[0].hepatitisBHepBVaccineDate !== compareHealthData.hepatitisBHepBVaccineDate)"
                    fieldType="hepatitisBHepBVaccineDate"
                    :approveRowId="value.vaccination[0].id"
                    :isChange = "value.vaccination[0].isChange"
                    :fieldValue="value.vaccination[0].hepatitisBHepBVaccineDate"
                    @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
                type="text"
                class="my-0 py-1"
                :value="value.vaccination && value.vaccination[0].hepatitisBHepBVaccineDate ? formatDate(value.vaccination[0].hepatitisBHepBVaccineDate) : formatDate(compareHealthData.hepatitisBHepBVaccineDate)"
                :class="value.vaccination && value.vaccination[0].hepatitisBHepBVaccineDate && (value.vaccination[0].hepatitisBHepBVaccineDate !== compareHealthData.hepatitisBHepBVaccineDate) ? 'custom-text-color' : ''"
                disabled
            />
        </v-col>
        <v-col cols="12" lg="4" sm="6">
            <div class="d-flex flex-row justify-space-between">
                <span class="body-2 font-weight-medium">
                    Tetanus - DTaP
                </span>
                <ApproveRejectButton
                  v-if="value.vaccination && value.vaccination[0].tetanusDTapDate && (value.vaccination[0].tetanusDTapDate !== compareHealthData.tetanusDTapDate)"
                  fieldType="tetanusDTapDate"
                  :approveRowId="value.vaccination[0].id"
                  :isChange = "value.vaccination[0].isChange"
                  :fieldValue="value.vaccination[0].tetanusDTapDate"
                  @click="approveRejectHealthRequest"
                />
            </div>
            <v-text-field
              type="text"
              class="my-0 py-1"
              :value="value.vaccination && value.vaccination[0].tetanusDTapDate ? formatDate(value.vaccination[0].tetanusDTapDate) : formatDate(compareHealthData.tetanusDTapDate)"
              :class="value.vaccination && value.vaccination[0].tetanusDTapDate && (value.vaccination[0].tetanusDTapDate !== compareHealthData.tetanusDTapDate) ? 'custom-text-color' : ''"
              disabled
            >
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <h1><span class="warning--text"><b>*DTaP is a combination vaccine that protects against
                Dptheria, Tetanus & Pertussis.</b></span></h1>
        </v-col>
        <v-col cols="12">
          <h1><span class="warning--text"><b>*MMR is a combination vaccine that protects against
                Measles, Mumps & Rubella.</b></span></h1>
        </v-col>
      </v-row>
    </v-card-component>
  </template>
<script>
import constants from '@/utils/constants'
import ApproveRejectButton from '@/components/Forms/Elements/ApproveRejectButtonElement'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import VCardComponent from '@/components/template/VCardComponent'
import moment from 'moment'
export default {
  name: 'ApproveHealthElement',
  props: {
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: false,
      type: Boolean
    },
    compareHealthData: {
      default: () => {},
      type: Object
    },
    enquiryID: {
      default: null,
      type: String
    }
  },
  components: {
    CustomDatePicker,
    ApproveRejectButton,
    VCardComponent
  },
  data: function () {
    return {
      isReadonly: false,
      isDisabled: false,
      cardTitle: '',
      cardIcon: '',
      maxToDate: moment().format('YYYY-MM-DD'),
      required: true,
      bloodGrp: '',
      bloodGroupList: [
        {
          id: 0,
          value: 'A+'
        },
        {
          id: 1,
          value: 'A-'
        },
        {
          id: 2,
          value: 'B+'
        },
        {
          id: 3,
          value: 'B-'
        },
        {
          id: 4,
          value: 'O+'
        },
        {
          id: 5,
          value: 'O-'
        },
        {
          id: 6,
          value: 'AB+'
        },
        {
          id: 7,
          value: 'AB-'
        }
      ]
    }
  },
  mounted () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  },

  created () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
    this.cardTitle = 'Health Details'
    this.cardIcon = 'mdi-account-heart'
    if (this.formType === 'edit_registration') {
      this.required = false
    }
    if (this.formType === 'registration') {
      this.required = false
    }
  },
  methods: {
    approveRejectHealthRequest: async function (data, type) {
      try {
        let title = ''
        let confirmText = ''
        let popupColor = ''
        if (type === 'Approve') {
          title = 'Approve field request'
          confirmText = 'Are you sure you want to approve the requested changes?'
          popupColor = 'info'
        } else {
          title = 'Reject field request.'
          confirmText = 'Are you sure you want to reject the requested changes?'
          popupColor = 'error'
        }
        this.$dialog.confirm({
          title: title,
          text: confirmText,
          type: popupColor,
          actions: {
            false: {
              text: 'No',
              handle: () => {
                this.$nextTick(() => {
                  return false
                })
              }
            },
            true: {
              color: 'success',
              text: 'Yes',
              handle: async () => {
                try {
                  let payload = {}
                  payload.statusType = type
                  payload.id = data.id
                  payload.type = 'health'
                  payload.isChange = data.isChange
                  payload.enquiryID = this.enquiryID
                  payload[data.fieldType] = data.fieldValue

                  if (payload.type === 'health' && data.isChange === 'medicalInfo' && data.fieldType === 'prescribedMedication') {
                    payload.healthCertificateDocID = data.file.id
                  } else {
                    payload.healthCertificateDocID = ''
                  }

                  const res = await http.post(`${constants.API_URL}/api/student/approve-edited-information`, payload)
                  if (res.status === 200) {
                    this.okMsg(res.data)
                    this.$emit('onStart')
                  }
                } catch (e) {
                  const errorMessage = (e && e.response && e.response.data.message) || e.message
                  this.errMsg(`In catch block of approveRejectHealthRequest function :${errorMessage}`)
                }
              }
            }
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    formatDate (date) {
      if (date) { return moment(date).format('DD/MM/YYYY') }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    }
  }
}
</script>
<style>
.custom-text-color > div.v-input__control > div.v-input__slot > div.v-text-field__slot > input{
    color:#ff0000!important;
}
.custom-text-color > div.v-input__control > div.v-input__slot > div.v-select__slot > input{
    color:#ff0000!important;
}
</style>
